import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import moment from "moment";
import { PageTemplate } from '../common/PageTemplate';
import * as types from "../../constants/actionTypes";
import { PhoneLink } from "../common/PhoneLink";
import { EmailLink } from "../common/EmailLink";
import * as FileSaver from 'file-saver';
import DataLoadingSpinner from "../common/DataLoadingSpinner";

const RequestAReview = () => {
    return <div className='request-a-review d-flex justify-content-center'><EmailLink
        emailAddress='SWHPGROUPENROLLMENT@bswhealth.org'
        subjectLine='1095B - Request a Review'
        linkText='Request a Review' />
    </div>;
}

const TaxFormMessage = (props) => {
    let { isSwhp } = props;
    let firstp = <span></span>;
    let planName = '';
    let phoneNumber = '';
    let hours = '';

    if (isSwhp) {
        firstp = 'To obtain a copy of your 1095-B tax statement:';
        planName = 'Baylor Scott & White Health Plan';
        phoneNumber = '1-844-633-5325';
        hours = 'from 7 a.m.to 7 p.m';
    }
    else {
        firstp = 'If you purchased your health insurance through Healthcare.gov, you may contact Healthcare.gov to obtain a copy of your 1095-B tax statement.';
        firstp += ' If you or your employer purchased your health insurance directly through FirstCare Health Plans, please send us a request for your 1095-B statement:';
        planName = 'FirstCare Health Plans';
        phoneNumber = '1-800-884-4901';
        hours = 'from 8 a.m.to 5 p.m';
    }

    return <div className='tax-form-message'>
        <div className='tax-message-title bold'>IMPORTANT MESSAGE about 1095-B tax statements regarding minimum essential coverage</div>
        {firstp}
        <div>Email us at <EmailLink emailAddress='SWHPGROUPENROLLMENT@BSWHealth.org' subjectLine=' 1095-B Request ' />
            <ol>
                <li>In the email subject line, please indicate “1095-B Request.”</li>
                <li>Include your name, member ID number (located on your ID card), mailing address, and phone number.</li>
            </ol>
        </div>
        <div>Or, mail your request to {planName}
            <ol>
                <li>Mail to 1206 W. Campus Drive, Temple, TX  76502.</li>
                <li>Include your name, member ID number (located on your ID number), mailing address, and phone number.</li>
            </ol>
        </div>
        <div>You will receive your 1095-B document up to 30 days after we receive your request.  If you have any questions, call Customer Service at <PhoneLink phoneNumber={phoneNumber} />, Monday through Friday, from {hours}.</div>

    </div>;
}

class TaxForms extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            memberId: this.props.hpIdentity ? this.props.hpIdentity.memberUserClaims.memberHccId : this.props.swhp,
            taxForms: null,
            fileName: ""
        };
    }

    componentDidMount = () => {
        if (this.state.memberId) {
            this.props.getDocumentsList(this.state.memberId);
        }
    }

    componentDidUpdate = (prevProps) => {
        if (!this.taxForms && (prevProps.swhp != this.props.swhp || prevProps.hpIdentity != this.props.hpIdentity)) {
            let newMemberId = this.props.hpIdentity ? this.props.hpIdentity.memberUserClaims.memberHccId : this.props.swhp;
            
            if (newMemberId && newMemberId !== "") {
                this.setState({ memberId: newMemberId });
                this.props.getDocumentsList(newMemberId);
            }
        }
        if (prevProps.documentsList != this.props.documentsList && this.props.documentsList) {
            //group tax docs by year
            var taxYears = this.props.documentsList.map(doc => doc.FormTaxYear)
                .filter((value, index, self) => self.indexOf(value) === index);
            var taxYearForms = taxYears.map(year => {
                return {
                    taxYear: year,
                    taxForms: this.props.documentsList.filter(doc => { return doc.FormTaxYear === year })
                }
            });

            this.setState({ taxForms: taxYearForms });
        }
        if (prevProps.documentUrl != this.props.documentUrl && this.props.documentUrl) {

            FileSaver.saveAs(this.props.documentUrl, this.state.fileName);
        }

    }

    onFormClick = (documentInfo) => {
        this.setState({ fileName: documentInfo.FormTaxYear + "_" + documentInfo.DocumentId + "_1095B.pdf" });
        this.props.getDocumentUrl(documentInfo.DocumentId, this.state.memberId);
    }

    formatCreatedOnDate = (createdOnDate) => {
        return createdOnDate ? ' - Created ' + moment(createdOnDate, "YYYY-MM-DD").format("L") : ''
    }


    renderErrorMessage = () => {
        return <div className='error'>No Tax Forms were found.</div>
    }

    renderMessage = () => {
        let firstp = <span></span>;
        let planName = '';
        let phoneNumber = '';
        let hours = '';

        if (this.props.swhp) {
            firstp = 'To obtain a copy of your 1095-B tax statement:';
            planName = 'Baylor Scott & White Health Plan';
            phoneNumber = '1-844-633-5325';
            hours = 'from 7 a.m.to 7 p.m';
        }
        else {
            firstp = 'If you purchased your health insurance through Healthcare.gov, you may contact Healthcare.gov to obtain a copy of your 1095-B tax statement';
            firstp += 'If you or your employer purchased your health insurance directly through FirstCare Health Plans, please send us a request for your 1095-B statement:';
            planName = 'FirstCare Health Plans';
            phoneNumber = '1-800-884-4901';
            hours = 'from 8 a.m.to 5 p.m';
        }

        return <div className='tax-form-message'>
            <div className='tax-message-title bold'>IMPORTANT MESSAGE about 1095-B tax statements regarding minimum essential coverage</div>
            {firstp}
            <div>Email us at <EmailLink emailAddress='SWHPGROUPENROLLMENT@BSWHealth.org' subjectLine=' 1095-B Request ' />
                <ol>
                    <li>In the email subject line, please indicate “1095-B Request.”</li>
                    <li>Include your name, member ID number (located on your ID card), mailing address, and phone number.</li>
                </ol>
            </div>
            <div>Or, mail your request to {planName}
                <ol>
                    <li>Mail to 1206 W. Campus Drive, Temple, TX  76502.</li>
                    <li>Include your name, member ID number (located on your ID number), mailing address, and phone number.</li>
                </ol>
            </div>
            <div>You will receive your 1095-B document up to 30 days after we receive your request.  If you have any questions, call Customer Service at <PhoneLink phoneNumber={phoneNumber} />, Monday through Friday, from {hours}.</div>

        </div>;
    }

    renderTaxYears = () => {
        return this.state.taxForms.map((taxYear) =>
            <div className='tax-year' key={'tax-year-' + taxYear.taxYear} >
                <div className='Title h3'>Tax Year {taxYear.taxYear}</div>
                {taxYear.taxForms.map((form) =>
                    <div className='tax-form' key={'tax-form-div-' + form.DocumentId}>
                        <button key={'tax-form-' + form.DocumentId} className='no-style-button' onClick={() => { this.onFormClick(form) }}>{form.FormType}{form.State ? ' - '+form.State : ''}{this.formatCreatedOnDate(form.CreatedDate)}</button>
                    </div>
                        )}
            </div>
        )
    }
    
    render = () => {
        return <PageTemplate objectName='tax-forms' pageTitle='Tax Forms'>
            <div className='text-block'>Listed below are the forms you may need when filing your taxes with the Internal Revenue Service (IRS). Just click on the link to download the form. The form that has no suffix or has the suffix "corrected" is the version you should submit. Forms marked "voided" contained errors and have been replaced by the corrected versions.</div>
            {this.state.taxForms && this.renderTaxYears()}
            {this.state.taxForms && this.state.taxForms.length === 0 && this.renderErrorMessage()}
            {!this.state.taxForms && <DataLoadingSpinner />}
            {this.state.taxForms && <TaxFormMessage isSwhp={this.props.swhp || (this.props.hpIdentity && this.props.hpIdentity.loginOrganization === "SWHPC")} />}
            {this.state.taxForms && <RequestAReview />}

        </PageTemplate>
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        documentsList: state.healthPlanServices.taxDocumentsList,
        documentUrl: state.healthPlanServices.taxDocumentUrl,
        error: state.healthPlanServices.error,
        hpIdentity: state.session.healthPlanUserProfile,
        swhp: state.domain.hi,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getDocumentsList: (memberNumber) => dispatch({ type: types.HP_GET_TAX_DOCUMENT_LIST_START, MemberNumber: memberNumber }),
        getDocumentUrl: (documentId, memberNumber) => dispatch({ type: types.HP_GET_TAX_DOCUMENT_URL_START, DocumentInfo: documentId, MemberNumber: memberNumber }),
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TaxForms));
